import CryptoAES from   "crypto-js/aes";
import CryptoENC from 'crypto-js/enc-utf8';
import CryptoMD5 from 'crypto-js/md5';
 

export function encrypt(message:String, key: String): String {
return CryptoAES.encrypt(message, key).toString();
}

export function decrypt(message:String, key: String): String {
    return CryptoAES.decrypt(message, key).toString(CryptoENC);
 }

 function hex2a(hexx) {
    var hex = hexx.toString();//force conversion
    var str = '';
    for (var i = 0; (i < hex.length && hex.substr(i, 2) !== '00'); i += 2)
        str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return str;
}

export function md5(key: string): string {
    return CryptoMD5(key).toString();
 }